import { z } from 'zod';

export const AccountSchema = z.object({
    first_name: z.string().min(3, { message: 'نام شخص حداقل 2 کاراکتر باشد' }),
    last_name: z.string().min(3, { message: 'نام‌خانوادگی باید حداقل 3 کاراکتر باشد' }),
    mobile: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    how_found_us: z.string().optional().nullable(),
    dob: z.number().optional().nullable()
});

export const AccountIdentitySchema = z.object({
    email: z.string().email('ایمیل معتبر نیست').optional(),
    mobile: z.string().min(11, 'شماره موبایل معتبر نیست').optional(),
    verification_code: z.string().length(4, 'کد تایید باید 4 رقمی باشد').optional()
});

export const AccountChangePasswordSchema = z
    .object({
        old_password: z.string().min(4, 'رمز عبور قبلی را وارد کنید'),
        password: z.string().min(4, 'رمز عبور جدید را وارد کنید'),
        password_confirmation: z.string().min(4, 'تکرار رمز عبور جدید را وارد کنید')
    })
    .refine((data) => data.password === data.password_confirmation, {
        path: ['password_confirmation'],
        message: 'رمز عبور جدید و تکرار آن یکسان نیستند'
    });

// Types
export type AccountFormValues = z.infer<typeof AccountSchema>;
export type AccountIdentityFormValues = z.infer<typeof AccountIdentitySchema>;
export type AccountChangePasswordFormValues = z.infer<typeof AccountChangePasswordSchema>;

